<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="sp" id="pt1"> </p>
<p class="Part-Number-pn"><span epub:type="pagebreak" id="pg_9" title="9"><span href="#/xhtml/contents#p_pt1" title="Link target outside of Sample"><span class="SANS-Nanoscopics-Alphabet-11">BOOK ONE</span></span></span></p>
<p class="Part-Epigraph-non-verse-pepi">I am become a name …</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?7564eb9e